export default class CustomValidator {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public install(vue: any, _options: unknown) {
    vue.prototype.$validator = this;
  }

  public required(v: string | number | undefined) {
    if (v === 0) {
      return true;
    }
    return !!v || '必須項目です';
  }

  public length(min: number, max: number, msg: string) {
    return (v: string) => {
      if (typeof v !== 'string') {
        return 'null';
      }

      if (min > v.length || max < v.length) {
        return msg;
      }
      return true;
    };
  }

  public minLength(length: number) {
    return (v: string) => {
      if (typeof v !== 'string') {
        return 'null';
      }

      if (v.length < length) {
        return `${length}文字以上`;
      }
      return true;
    };
  }

  public password(v: string) {
    const msg = '半角英数字8文字以上';
    if (typeof v !== 'string') {
      return msg;
    }
    if (v.length < 8) {
      return msg;
    }
    const reg = /^[a-z0-9]{8,}$/i;
    if (!reg.test(v)) {
      return msg;
    }
    return true;
  }

  public max(max: number) {
    return (v: number) => {
      if (typeof v !== 'number') {
        return '数値を入力';
      }
      if (v > max) {
        return `${max}以下`;
      }
      return true;
    };
  }

  public min(min: number) {
    return (v: number) => {
      if (typeof v !== 'number') {
        return '数値を入力';
      }
      if (v < min) {
        return `${min}以上`;
      }
      return true;
    };
  }

  public mailaddress(v: string) {
    // tslint:disable-next-line: max-line-length
    const reg = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    if (!reg.test(v)) {
      return '有効なアドレスを入力';
    }
    return true;
  }

  public space() {
    return (v: string) => {
      const reg = /^\s+$/i;
      if (reg.test(v)) {
        return '必須項目です';
      }
      return true;
    };
  }

  public time(v: string) {
    if (typeof v !== 'string') {
      return false;
    }

    const reg = /^[0-2][0-9]:[0-5][0-9]$/;
    if (!reg.test(v)) {
      return false;
    }

    const parts = v.split(':');
    if (parseInt(parts[0], 10) > 24) {
      return false;
    }
    if (parseInt(parts[1], 10) > 60) {
      return false;
    }
    return true;
  }

  public workHours(v: number) {
    if (typeof v !== 'number') {
      return false;
    }

    if (v % 0.25 !== 0) {
      return false;
    }
    return true;
  }
}
